/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */

import { Component, OnInit } from '@angular/core';
import { FeaturedCategoriesService } from '../../../services/Home/featured-categories.service';
import { MOloop } from './../../../pipes/mo-loop.pipe';
import * as $ from 'jquery';


@Component({
  selector: 'martmax-features-categories',
  templateUrl: './featured-categories.component.html',
  styleUrls: ['./featured-categories.component.css'],
  providers: [FeaturedCategoriesService],
})
export class FeaturedCategoriesComponent implements OnInit{

  config: SwiperOptions = {
    pagination: '.swiper-pagination',
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    freeMode: true,
    autoplay: 2000,
    loop: true,
  };

  public errors: any;
  public featuredCategories: any;
  public categoryName: any;

  constructor(public featuredCategoriesService: FeaturedCategoriesService) {
  }

  public ngOnInit() {    

    this.featuredCategoriesService.getFeaturedCategories().subscribe(
      (data) => {
        this.jquery();

        if (data.length === 0) {
          return;
        }
        this.featuredCategories = data.featuredCategories;

      },
      (errors) => {
        this.errors = errors;
      }
    );
  }

  private jquery() {
    setTimeout(() => {
        // Statoc Category
        $('.static-category').on('mouseover', function () {
          let btn = $(this),
                background = btn.data('background');

          btn.css('background-color', background).addClass('with-white-img');

        });

        $('.static-category').on('mouseleave', function () {
          let btn = $(this);

          btn.css('background-color', '#FFF').removeClass('with-white-img');

          $('.static-category').first().trigger('mouseover');
        });

        $('.static-category').first().trigger('mouseover');

    }, 3000);
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/components/home-page/featured-categories/featured-categories.component.ts